import { TicketRouteMap } from '../types/ticket-route-map';
import { RouteNames } from './routes';

export const TICKET_ROUTE_MAP: TicketRouteMap = {
  selector_tickets_and_passes_title: RouteNames.TICKET_SELECTOR,
  selector_flexible_title: RouteNames.FLEXIBLE_TICKETS,
  selector_pay_as_you_go_title: RouteNames.PAYG_TICKETS,
};
